<app-breadcrumb [title]="'Inventario de Vías Administradas'" [items]="['Pesv']"
  [active_item]="'Inventario de Vías'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="fa fa-road me-2"></i>
      <h5 class="mb-0"><strong>REGISTRO DE VÍAS ADMINISTRADAS</strong></h5>
    </div>

    <div class="card-body">
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 1" (click)="activeTab = 1">
            <i class="fa fa-plus me-1"></i>{{ editando ? 'Editar vía' : 'Registrar vía' }}
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 2" (click)="mostrarListado()">
            <i class="fa fa-list me-1"></i>Listado de vías
          </button>
        </li>
      </ul>

      <form *ngIf="activeTab === 1" [formGroup]="form" (ngSubmit)="guardar()">
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-info-circle me-2"></i>
            1. Información general
          </div>

          <div class="row g-3 mt-2">

            <div class="col-md-4">
              <label class="form-label required">Sede: <span class="text-danger">*</span></label>
              <ng-select [items]="sedes" placeholder="Seleccione una sede" bindLabel="nombre_sede" bindValue="id"
                formControlName="sede">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label required">Nombre de la vía: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="nombre" placeholder="Vía de acceso principal" />
            </div>

            <div class="col-md-4">
              <label class="form-label required">Tipo de vía: <span class="text-danger">*</span></label>
              <ng-select [items]="tiposVia" placeholder="Seleccione un tipo de vía" bindLabel="nombre" bindValue="id"
                formControlName="tipo_via">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label required">Código: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="codigo" placeholder="VI-001" />
            </div>

            <div class="col-md-4">
              <label class="form-label required">Fecha de registro: <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="fecha_registro" />
            </div>

            <div class="col-md-4">
              <label class="form-label required">Responsable: <span class="text-danger">*</span></label>
              <ng-select [items]="responsables" placeholder="Seleccione un responsable" bindLabel="nombreConCargo"
                bindValue="cedula" formControlName="responsable" (change)="seleccionarResponsable($event)">
              </ng-select>
            </div>

            <div class="col-md-12">
              <label class="form-label required">Descripción: <span class="text-danger">*</span></label>
              <textarea class="form-control" rows="3" formControlName="descripcion"></textarea>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-road me-2"></i>
            2. Características técnicas
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-3">
              <label class="form-label required">Longitud (m): <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese la longitud en metros" class="form-control"
                formControlName="longitud_m" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Ancho (m): <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese el ancho en metros" class="form-control"
                formControlName="ancho_m" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Número de carriles: <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese el número de carriles" class="form-control"
                formControlName="numero_carriles" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Sentido de circulación: <span class="text-danger">*</span></label>
              <ng-select [items]="sentidosCirculacion" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un sentido de circulación"
                formControlName="sentido_circulacion">
              </ng-select>
              
            </div>

            <div class="col-md-3">
              <label class="form-label required">Tipo de superficie: <span class="text-danger">*</span></label>

              <ng-select [items]="tiposSuperficieCatalogo" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un tipo de superficie"
                formControlName="tipo_superficie">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Estado de la superficie: <span class="text-danger">*</span></label>
              <ng-select [items]="estadosSuperficie" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un estado de la superficie"
                formControlName="estado_superficie">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Pendiente: <span class="text-danger">*</span></label>
              <ng-select [items]="pendientes" placeholder="Seleccione una pendiente" formControlName="pendiente">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Velocidad máxima permitida: <span class="text-danger">*</span></label>
              <div class="input-group">
                <input type="number" placeholder="Ingrese la velocidad máxima permitida" class="form-control"
                  formControlName="velocidad_maxima_kmh" />
                <span class="input-group-text">km/h</span>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-map-marker me-2"></i>
            3. Ubicación y mapa
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-6">
              <label class="form-label required">Dirección / Descripción de ubicación: <span class="text-danger">*</span></label>
              <input type="text" placeholder="Ingrese la dirección o descripción de ubicación" class="form-control"
                formControlName="direccion" />
            </div>

            <div class="col-md-6">
              <label class="form-label required">Mapa de ubicación: <span class="text-danger">*</span></label>
              <div class="d-flex align-items-center gap-2">
                <div class="flex-grow-1 border rounded bg-light map-box overflow-hidden">
                  <iframe *ngIf="mapUrl" class="map-frame" [src]="mapUrl" title="Mapa de ubicación"></iframe>
                  <div *ngIf="!mapUrl"
                    class="map-placeholder text-center text-muted d-flex align-items-center justify-content-center">
                    <span><i class="fa fa-map me-2"></i>Ingrese coordenadas válidas</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Municipio: <span class="text-danger">*</span></label>
              <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN" placeholder="Seleccione un municipio" formControlName="municipio">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Departamento: <span class="text-danger">*</span></label>
              <ng-select [items]="departamentos" placeholder="Seleccione un departamento" bindLabel="nombre" bindValue="id_departamento"
                formControlName="departamento">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Latitud: <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese la latitud" class="form-control" formControlName="latitud"
                step="0.0001" (input)="actualizarMapa()" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Longitud: <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese la longitud" class="form-control" formControlName="longitud"
                step="0.0001" (input)="actualizarMapa()" />
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-camera me-2"></i>
            4. Registro fotográfico
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-3" *ngFor="let etiqueta of etiquetasFotos; let indice = index">
              <div class="photo-card">
                <div class="photo-placeholder d-flex align-items-center justify-content-center"
                  [class.has-photo]="fotosPreview[indice]">
                  <img *ngIf="fotosPreview[indice]" [src]="fotosPreview[indice]" [alt]="etiqueta" />
                  <i *ngIf="!fotosPreview[indice]" class="fa fa-image"></i>
                </div>
                <div class="photo-label text-center mt-2">{{ etiqueta }}</div>
                <label class="btn btn-outline-primary btn-sm w-100 mt-2">
                  <i class="fa fa-upload me-1"></i>{{ fotosPreview[indice] ? 'Cambiar imagen' : 'Cargar imagen' }}
                  <input type="file" class="d-none" accept="image/*" (change)="seleccionarFoto($event, indice)" />
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-light border text-secondary px-4" (click)="cancelar()">Cancelar</button>

            <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">{{ guardando ? 'Guardando...' :
              'Guardar' }}</button>
          </div>
        </div>
      </form>

      <div *ngIf="activeTab === 2">
        <div class="row mb-3 align-items-center">
          <div class="col-md-4">
            <input type="search" class="form-control" [(ngModel)]="filtro" (input)="aplicarFiltro()"
              placeholder="Buscar por código, nombre o municipio..." />
          </div>
        </div>

        <div *ngIf="cargandoListado" class="text-center py-4">
          <span class="spinner-border text-primary"></span>
          <p class="mt-2 mb-0">Cargando vías...</p>
        </div>

        <div *ngIf="!cargandoListado" class="table-responsive">
          <table id="tblViasInternas" class="table table-bordered table-hover align-middle">
            <thead class="bg-primary text-white">
              <tr>
                <th class="text-center">CÓDIGO</th>
                <th class="text-center">SEDE</th>
                <th class="text-center">NOMBRE</th>
                <th class="text-center">RESPONSABLE</th>
                <th class="text-center">TIPO DE VÍA</th>
                <th class="text-center">SENTIDO CIRCULACIÓN</th>
                <th class="text-center">DIRECCIÓN</th>
                <th class="text-center">MUNICIPIO</th>
                <th class="text-center">ESTADO</th>
                <th class="text-center">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let via of viasFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                <td class="text-center">{{ via.codigo }}</td>
                <td class="text-center">{{ via.SedeViasData?.nombre_sede }}</td>
                <td class="text-uppercase">{{ via.nombre }}</td>
                <td class="text-center">{{ via.ResponsableInternaData?.nombreCompleto }}</td>
                <td class="text-center">{{ via.TipoViaInternaData?.nombre }}</td>
                <td class="text-center">{{ via.SentidoCirculacionViasData?.descripcion }}</td>
                <td class="text-center">{{ via.direccion }}</td>
                <td class="text-center">{{ via.MunicipioViasData?.MUNICIPIO }} - {{ via.DepartamentoViasData?.nombre }}</td>
                <td class="text-center">
                  <span class="badge" [ngClass]="Number(via.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                    {{ Number(via.estado) === 1 ? 'ACTIVA' : 'INACTIVA' }}
                  </span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-primary me-1 rounded-pill btn-rounded" (click)="editarVia(via)"
                    [disabled]="Number(via.estado) !== 1" title="Editar">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button type="button" class="btn btn-sm rounded-pill btn-rounded"
                    [ngClass]="Number(via.estado) === 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                    (click)="cambiarEstado(via)" [title]="Number(via.estado) === 1 ? 'Inactivar' : 'Activar'">
                    <i class="fa" [ngClass]="Number(via.estado) === 1 ? 'fa-ban' : 'fa-check'"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!viasFiltradas.length">
                <td colspan="10" class="text-center text-primary py-4">No hay vías registradas.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4" *ngIf="viasFiltradas.length > 0">
          <div class="d-flex align-items-center">
            <label class="me-2">Mostrar:</label>
            <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
          <div class="text-center flex-grow-1">
            Total Registros: <a class="badge badge-primary"><b>{{ viasFiltradas?.length || 0 }}</b></a>
          </div>
          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
              [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
          </div>
        </div>

        <div class="btn-showcase text-center mt-4" *ngIf="viasFiltradas.length">
          <button type="button" class="btn btn-outline-success-2x me-2" (click)="exportarExcel()">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>
          <button type="button" class="btn btn-outline-danger-2x" (click)="exportarPdf()">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>